var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93306 19.834H14.733C17.7843 19.834 19.8335 17.6937 19.8335 14.5089V7.15903C19.8335 3.97429 17.7843 1.83398 14.7339 1.83398H6.93306C3.8827 1.83398 1.8335 3.97429 1.8335 7.15903V14.5089C1.8335 17.6937 3.8827 19.834 6.93306 19.834ZM7.79078 10.084C6.52702 10.084 5.50016 9.05573 5.50016 7.79232C5.50016 6.5289 6.52702 5.50065 7.79078 5.50065C9.05362 5.50065 10.0814 6.5289 10.0814 7.79232C10.0814 9.05573 9.05362 10.084 7.79078 10.084ZM18.1692 13.6901C18.4762 14.4772 18.3167 15.4232 17.9886 16.2027C17.5996 17.1297 16.8548 17.8317 15.9164 18.1382C15.4998 18.2744 15.0628 18.334 14.6268 18.334H6.90142C6.13266 18.334 5.45238 18.1495 4.89471 17.8061C4.54535 17.5904 4.48359 17.0928 4.74261 16.7703C5.17585 16.231 5.60356 15.6899 6.03495 15.1441C6.85717 14.0997 7.41116 13.797 8.02691 14.0628C8.27671 14.1726 8.52744 14.3372 8.78554 14.5112C9.47318 14.9785 10.4291 15.6209 11.6882 14.9237C12.5499 14.4411 13.0496 13.6133 13.4849 12.8924L13.4921 12.8803C13.523 12.8298 13.5535 12.7792 13.584 12.7288C13.7303 12.4867 13.8746 12.248 14.0378 12.028C14.2425 11.7527 15.0011 10.8919 15.9837 11.5049C16.6096 11.8908 17.1359 12.413 17.6991 12.9721C17.9139 13.1859 18.0669 13.429 18.1692 13.6901Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditing);
export default __webpack_public_path__ + "static/media/editing.2405de15916c7aeb3ea7d4d456c754d4.svg";
export { ForwardRef as ReactComponent };